import Cookie from './cookie';
import { config } from '/app/config';
import { redirectTo, currentURL } from './navigation';

const authKeyName = config.auth.cookieName;
const authKeyNameShadow = `${authKeyName}_shadow`;
const authKeyNameStaff = `${authKeyName}_staff`;

export const Session = {
    setToken (token) {
        return Cookie.set(authKeyName, token, true, 7);
    },
    getToken () {
        return Cookie.get(authKeyNameStaff) || Cookie.get(authKeyNameShadow) || Cookie.get(authKeyName);
    },
    isAuthenticated () {
        return Cookie.has(authKeyName) || Cookie.has(authKeyNameShadow) || Cookie.has(authKeyNameStaff);
    },
    exists () {
        return Cookie.has(authKeyName) || Cookie.has(authKeyNameShadow) || Cookie.has(authKeyNameStaff);
    },
    remove () {
        Cookie.delete('notification_token', true);
        Cookie.delete(authKeyName, true);
        Cookie.delete(authKeyName, false);
        Cookie.delete(authKeyNameShadow, true);
        Cookie.delete(authKeyNameShadow, false);
        Cookie.delete(authKeyNameStaff, true);
        Cookie.delete(authKeyNameStaff, false);
    },
    isShadow () {
        return Cookie.has(authKeyNameShadow);
    },
    isStaff () {
        return Cookie.has(authKeyNameStaff);
    },
    startStaff (token) {
        return Cookie.set(authKeyNameStaff, token, true);
    },
    stopStaff () {
        // delete both the shared (cross-subdomain) cookie and any
        // legacy host-only cookie set before staff mode was shared
        Cookie.delete(authKeyNameStaff, true);
        return Cookie.delete(authKeyNameStaff, false);
    },
    startShadow (token) {
        return Cookie.set(authKeyNameShadow, token, true);
    },
    stopShadow () {
        // delete both the shared (cross-subdomain) cookie and any
        // legacy host-only cookie set before shadow mode was shared
        Cookie.delete(authKeyNameShadow, true);
        return Cookie.delete(authKeyNameShadow, false);
    },
}

/**
 * Clear the local session and send the user through the account logout
 * flow to re-authenticate, returning to the current page afterwards.
 * Pure (no composable deps) so it is safe from router guards and axios
 * interceptors, outside component setup.
 */
export function forceReauth() {
    if (typeof window === 'undefined') return;

    Session.remove();

    const [, appName] = location.hostname.split('.').reverse();
    const continueURL = encodeURIComponent(currentURL());

    redirectTo(`${config.account.url}/logout?continue=${continueURL}&platform=${appName}`);
}